import { render, staticRenderFns } from "./BP_page_edit.vue?vue&type=template&id=3fd1d66c"
import script from "./BP_page_edit.vue?vue&type=script&lang=js"
export * from "./BP_page_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports